<template>
    <div>
        <nav class="level is-block-tablet-only is-block-desktop-only">
            <div class="level-left is-block-tablet-only is-block-desktop-only">
            </div>

            <div class="level-right is-block-tablet-only is-block-desktop-only">
                <div class="level-item is-block-mobile is-block-tablet-only is-block-desktop-only">
                    <div class="field">
                        <label class="label is-size-7 has-text-weight-medium">
                            From date
                        </label>
                        <b-datepicker
                            v-model="fromDate"
                            placeholder="Search from..."
                            :min-date="minimumDate ? $dayjs(minimumDate).toDate() : null"
                            :max-date="toDate"
                            icon="calendar-alt"
                            locale="en-GB"
                            @input="searchNotes"
                        />
                    </div>
                </div>
                <div class="level-item is-block-mobile is-block-tablet-only is-block-desktop-only">
                    <div class="field">
                        <label class="label is-size-7 has-text-weight-medium">
                            To date
                        </label>
                        <b-datepicker
                            v-model="toDate"
                            placeholder="Search to..."
                            :min-date="fromDate"
                            :max-date="$dayjs().toDate()"
                            icon="calendar-alt"
                            locale="en-GB"
                            @input="searchNotes"
                        />
                    </div>
                </div>
            </div>
        </nav>

        <NoteTypes
            :types="parsedNoteTypes"
            :selected-types.sync="selectedTypes"
            :is-disabled="isLoading"
        />

        <Notification v-if="! noteTypes">
            Loading...
        </Notification>

        <Notification v-else-if="! parsedNoteTypes.length">
            No documents found.
        </Notification>

        <div
            v-else-if="! notes"
            class="columns is-multiline"
        >
            <SkeletonCard
                :count="4"
                :classes="classes"
            />
        </div>

        <Notification v-else-if="! hasNotes">
            No documents found.
        </Notification>

        <div
            v-else
            class="columns is-multiline"
        >
            <Note
                v-for="note in notes.Rows"
                :key="note.NotePK"
                :note="note"
                :class="classes"
            />
        </div>

        <b-pagination
            v-if="hasNotes && notes.RowCount > limit"
            class="mt-3"
            :total="notes.RowCount"
            :current.sync="page"
            order="is-centered"
            range-before="2"
            range-after="2"
            :per-page="limit"
            @change="searchNotes(false)"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Notification from './Notification.vue';
import Note from './Note.vue';
import SkeletonCard from './SkeletonCard.vue';
import NoteTypes from './NoteTypes.vue';

export default {
    components: {
        Notification,
        Note,
        SkeletonCard,
        NoteTypes,
    },

    props: {
        classes: {
            type: String,
            default: 'is-12',
        },
    },

    data: function() {
        const { query } = this.$route;

        return {
            page: Number(this.$route.query.page || 1),
            limit: 12,
            selectedTypes: [],
            isLoading: false,
            fromDate: query.fromDate ? this.$dayjs.unix(Number(query.fromDate)).toDate() : this.$dayjs().subtract(1, 'year').toDate(),
            toDate: query.toDate ? this.$dayjs.unix(Number(query.toDate)).toDate() : this.$dayjs().toDate(),
        };
    },

    computed: {
        ...mapState('tenancyProperty', [
            'notes',
            'noteTypes',
        ]),

        ...mapGetters('tenancyProperty', [
            'hasNotes',
            'parsedNoteTypes',
        ]),

        minimumDate() {
            return this.$meta.features.tenants.documents_from;
        },

         queryParams() {
            return {
                ...this.$data,
                // change format of dates to timestamp
                fromDate: this.$dayjs(this.fromDate).unix(),
                toDate: this.$dayjs(this.toDate).unix(),
            };
        },
    },

    watch: {
        selectedTypes: function () {
            this.searchNotes();
        },
    },

    mounted() {
        this.$store.dispatch('tenancyProperty/getNoteTypes');
    },

    methods: {
        searchNotes(resetPagination = true) {
            this.isLoading = true;

            if (resetPagination) {
                this.page = 1;
            }

            this.$router.push({
                query: this.queryParams,
            });

            this.getNotes()
            .then(() => {
                this.isLoading = false;
            });
        },
        getNotes() {
            return this.$store.dispatch('tenancyProperty/getNotes', this.$data);
        },
    },
};
</script>
